'use strict'

import CustomSelect from "../../utils/CustomSelect";

class WhatWeDoClients{
    constructor(){
        this.main = document.querySelector('.section_our_clients');

        if(!this.main){
            return;
        }
        
        this._data = JSON.parse(this.main.getAttribute('data-clients'));
        
        this._native_select = this.main.querySelector('select[name="filter_clients"]');
        this._selectCategory = new CustomSelect(this.main.querySelector('select[name="filter_clients"]'));

        this._holder = this.main.querySelector('.holder_clients');
        this._setItems(this._selectCategory.value);

        this._selected = this.main.querySelector('.select-selected');
        this._native_select.addEventListener('change', (element) => {
            
            this._selected.innerHTML = element.target.options[element.target.selectedIndex].innerHTML;
        });

        this._selectCategory.addEventListener('change', this._onChangeSelectCategory.bind(this));
    }


    _onChangeSelectCategory(e){
        this._setItems(this._selectCategory.value);
    }

    _setItems(category){
        this._holder.innerHTML = '';
        this._data.forEach((itemData)=>{
            if(itemData.category == category){
                let item = new WhatWeDoClientsIten(itemData);
                this._holder.appendChild(item.main);
            }
        });
    }
}


class WhatWeDoClientsIten{
    constructor(data){
        this.main = document.createElement('div');
        this.main.innerHTML =  /*html*/`<div class="fadeInUp" data-wow-delay="0.2s"><!-- col-4 col-sm-3 col-md-2 col-xl-1 -->
                                            <a href="#" class="logo-grayscale">
                                                <div class="logo-grayscale__wrapper">
                                                    <img class="logo-grayscale__img" src="${App.filesPath + data.logo}" alt="${data.name}">
                                                </div>
                                            </a>
                                        </div>`;
        this.main = this.main.firstChild;
    }
}

export default WhatWeDoClients;